import { IS_PROD } from "./constants"

const showFlag = !IS_PROD

export const Flags = {
  General: {
    Example: showFlag,
    Theming: false,
    Rebrand: true,
    CSLeaseChart: true,
    CSLeaseChartPdf: true,
    ProjectHeader: true,
  },
} as const

export type FlagsType = typeof Flags
